export default __webpack_public_path__ + "static/media/al.04639487.svg";